// Per-step inline validation for the booking wizard. Mirrors validateBooking()
// in pages/bookingFields.js — same rules, surfaced field-by-field as you go.
const req = (v) => String(v ?? "").trim().length > 0;

export function stepIssues(step, form, formType) {
  const e = {};
  if (formType === "internal") {
    // SALES-022 internal steps: [0] Type & Use, [1] Dates & Vehicle, [2] Review.
    if (step === 0 && !req(form.internal_user)) e.internal_user = "Enter who is using the car";
    if (step === 1) {
      if (!req(form.start_datetime)) e.start_datetime = "Pick a start date & time";
      if (!req(form.end_datetime)) e.end_datetime = "Pick an end date & time";
      if (req(form.start_datetime) && req(form.end_datetime) && form.end_datetime < form.start_datetime) {
        e.end_datetime = "End must be after the start";
      }
      if (!req(form.vehicle_id)) e.vehicle_id = "Select a vehicle";
    }
    return e;
  }
  if (step === 0) {
    if (!req(form.customer_name)) e.customer_name = "Client name is required";
    if (!req(form.salesperson)) e.salesperson = "Choose who is booking this";
    if (String(form.salesperson ?? "").trim().toLowerCase() === "affiliate" && !req(form.affiliate_name)) {
      e.affiliate_name = "Pick which affiliate brought this in";
    }
    if (!req(form.customer_phone)) e.customer_phone = "Phone number is required";
    if (formType === "rental") {
      if (!req(form.client_age)) e.client_age = "Age is required";
      if (!req(form.credit_card)) e.credit_card = "Credit card is required";
      if (!req(form.insurance_coverage)) e.insurance_coverage = "Choose Yes or No";
    }
  }
  if (step === 1) {
    if (!req(form.start_datetime)) e.start_datetime = "Pick a start date & time";
    if (!req(form.end_datetime)) e.end_datetime = "Pick an end date & time";
    if (req(form.start_datetime) && req(form.end_datetime) && form.end_datetime < form.start_datetime) {
      e.end_datetime = "End must be after the start";
    }
    if (!req(form.vehicle_id)) e.vehicle_id = "Select a vehicle";
  }
  if (step === 2) {
    if (formType === "rental") {
      if (!(Number(form.rental_rate) > 0)) e.rental_rate = "Rate is required";
      if (!req(form.deposit_amount)) e.deposit_amount = "Deposit amount is required";
      if (!req(form.booking_category)) e.booking_category = "Pick a category";
    } else {
      if (!req(form.start_location)) e.start_location = "Pickup location is required";
      if (!req(form.end_location)) e.end_location = "Drop-off location is required";
      // Zero is a valid answer here, so "filled in" is the test, not "> 0".
      if (!req(form.depo_sent)) e.depo_sent = "Enter the deposit — 0 if none was taken";
      if ((form.pricing_mode || "hourly") !== "flat" && !(Number(form.hourly_rate) > 0)
          && !String(form.package_id || "").trim()) {
        e.hourly_rate = 'Hourly rate is required — or charge for the whole job';
      }
    }
    if (!(Number(form.total) > 0)) e.total = "Total must be greater than 0";
  }
  return e;
}

export const hasIssues = (e) => Object.keys(e).length > 0;
